import { z } from "zod";

export const contactFormSchema = z.object({
  name: z
    .string()
    .trim()
    .min(1, { message: "Ime je obvezno" })
    .max(100, { message: "Ime je predolgo (max 100 znakov)" }),
  email: z
    .string()
    .trim()
    .min(1, { message: "E-pošta je obvezna" })
    .email({ message: "Vnesite veljaven e-poštni naslov" })
    .max(255, { message: "E-pošta je predolga" }),
  phone: z
    .string()
    .trim()
    .max(50, { message: "Telefonska številka je predolga" })
    .optional()
    .or(z.literal("")),
  subject: z
    .string()
    .trim()
    .min(1, { message: "Zadeva je obvezna" })
    .max(200, { message: "Zadeva je predolga (max 200 znakov)" }),
  message: z
    .string()
    .trim()
    .min(1, { message: "Sporočilo je obvezno" })
    .max(5000, { message: "Sporočilo je predolgo (max 5000 znakov)" }),
});

export type ContactFormData = z.infer<typeof contactFormSchema>;
